import { connect } from 'react-redux'
import { getCarrierDetails } from 'utils/actions/carrier'
import { openDialog } from 'utils/actions/user'
import { UserDetailsComponent } from '../UserDetails'

export const UserDetails = connect(
  ({
    userProfile: { userProfileDetails = {}, isDriver, isDispatcher, isOwnerOperator },
    childUsers: { users },
    carrier: { carrierDetails, error: carrierFetchError, isFetching: carrierFetching },
  }) => ({
    ...(!(isDriver || isDispatcher || isOwnerOperator)
      ? users[0] || userProfileDetails
      : userProfileDetails),
    ...(carrierDetails
      ? {
          companyLegalName: carrierDetails.legalName,
          companyDot: carrierDetails.dotNumber,
          companyMc: carrierDetails.mcNumber,
        }
      : {}),
    carrierFetching,
    carrierFetchError,
    applicationId: userProfileDetails.applicationId,
    showUserAccounts: isDriver || isDispatcher || isOwnerOperator,
  }),
  { edit: openDialog, getCarrierDetails }
)(UserDetailsComponent)
